import React, { useState } from 'react';
import CenterModule from '../CenterModule/CenterModule'; // Ensure this path matches your file structure
import './SetPackingPreferencesModal.css';

export const SetPackingPreferencesModal = ({ open, onClose, onConfirm }) => {
  const [integrityOption, setIntegrityOption] = useState('');
  const [smallOnTop, setSmallOnTop] = useState(false);
  const [largeBehindSmall, setLargeBehindSmall] = useState(false);
  const [useShelves, setUseShelves] = useState('');

  if (!open) return null;

  const isFormValid = integrityOption !== '' && useShelves !== '';

  const handleConfirm = () => {
    if (!isFormValid) return;

    onConfirm({
      integrityOption,
      parameters: {
        smallOnTop,
        largeBehindSmall,
      },
      useShelves: useShelves === 'yes',
    });
  };

  return (
    <div className="">
      <CenterModule>
        <div className="preferences-modal">
          {/* Header */}
          <div className="modal-header">
            <h2>Set Packing Preferences</h2>
            <button className="close-btn" onClick={onClose} aria-label="Close">
              &times;
            </button>
          </div>

          <hr className="divider" />

          <div className="modal-body">
            {/* Section 1: Radio Buttons */}
            <div className="section">
              <p className="section-title">
                Select one option of how kits and NSNs should be organized:
              </p>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="integrityOption"
                    value="kit_integrity"
                    checked={integrityOption === 'kit_integrity'}
                    onChange={(e) => setIntegrityOption(e.target.value)}
                  />
                  <span>
                    <strong>Kit Integrity:</strong> Keep all items from the same kit packed together, with no mixing between kits.
                  </span>
                </label>

                <label className="radio-label">
                  <input
                    type="radio"
                    name="integrityOption"
                    value="nsn_integrity"
                    checked={integrityOption === 'nsn_integrity'}
                    onChange={(e) => setIntegrityOption(e.target.value)}
                  />
                  <span>
                    <strong>NSN Integrity:</strong> Keep all items sharing the same NSN packed together.
                  </span>
                </label>

                <label className="radio-label">
                  <input
                    type="radio"
                    name="integrityOption"
                    value="kit_and_nsn_integrity"
                    checked={integrityOption === 'kit_and_nsn_integrity'}
                    onChange={(e) => setIntegrityOption(e.target.value)}
                  />
                  <span>
                    <strong>Kit and NSN Integrity:</strong> Group and pack all NSNs within each kit together, for easier retrieval.
                  </span>
                </label>

                <label className="radio-label">
                  <input
                    type="radio"
                    name="integrityOption"
                    value="no_integrity"
                    checked={integrityOption === 'no_integrity'}
                    onChange={(e) => setIntegrityOption(e.target.value)}
                  />
                  <span>
                    <strong>No Integrity — Free Packing:</strong> Pack items freely, without kit or NSN grouping.
                  </span>
                </label>
              </div>
            </div>

            {/* Section 2: Checkboxes */}
            <div className="section">
              <p className="section-title">Select parameters to help your packing:</p>
              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={smallOnTop}
                    onChange={(e) => setSmallOnTop(e.target.checked)}
                  />
                  <span>Small on Top, Big on Bottom</span>
                </label>

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={largeBehindSmall}
                    onChange={(e) => setLargeBehindSmall(e.target.checked)}
                  />
                  <span>Large behind small</span>
                </label>
              </div>
            </div>

            {/* Section 3: Shelves */}
            <div className="section">
              <p className="section-title">Do you want to use shelves?</p>
              <div className="radio-group horizontal">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="useShelves"
                    value="yes"
                    checked={useShelves === 'yes'}
                    onChange={(e) => setUseShelves(e.target.value)}
                  />
                  <span>Yes, use shelves</span>
                </label>

                <label className="radio-label">
                  <input
                    type="radio"
                    name="useShelves"
                    value="no"
                    checked={useShelves === 'no'}
                    onChange={(e) => setUseShelves(e.target.value)}
                  />
                  <span>No shelves</span>
                </label>
              </div>
            </div>
          </div>

          <hr className="divider" />

          {/* Footer Actions */}
          <div className="modal-footer">
            <button className="btn btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-confirm"
              disabled={!isFormValid}
              onClick={handleConfirm}
            >
              Confirm and Continue
            </button>
          </div>
        </div>
      </CenterModule>
    </div>
  );
};

export default SetPackingPreferencesModal;